export default "__VITE_PUBLIC_ASSET__f6898169__"